<!-- <p>{{userProfile | json}}</p> -->
<div class="otp-body">
    <div class="m-2">
        <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
    </div>
    <div class="mt-2 mb-2">
        <label class="label-click" (click)="onSendOtpAgain()"><i class="fas fa-sync-alt"></i>&nbsp; ส่งรหัสยืนยัน OTP ใหม่อีกครั้ง</label>
    </div>
</div>